export default __webpack_public_path__ + "static/media/logo_alphalitical.886ae86c.png";